import { render, staticRenderFns } from "./InteractiveFeatures.vue?vue&type=template&id=c634f8a2&scoped=true&"
import script from "./InteractiveFeatures.vue?vue&type=script&lang=ts&"
export * from "./InteractiveFeatures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c634f8a2",
  null
  
)

export default component.exports
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QList});
